/**
 * The image strip in the site footer (between the link columns and the contact row). Change the picture or its copy here —
 * FooterIndustrialVisual never contains an image URL or text of its own. Set `null` to remove the strip.
 *
 * Image: /images/company/tube-cleaning-services.webp — a real Shingare photograph (source: tubecleaner.co.in `Tube-Cleaning-Services.jpg`,
 * Services page): a Shingare technician cleaning the tube sheet of a heat exchanger with a cleaning lance and blue hose, i.e. the
 * company's core product in a real application. It is only 648×550, so the component never stretches it: the photo is shown at
 * (or below) its native size on the right and continues to the left as a blurred, navy-tinted copy of itself.
 *
 * `position` = CSS object-position of the sharp photo per breakpoint (keeps the technician's head, hose and tube sheet in frame).
 * The copy only restates what the site already says about the range (tube, bolting, pipe preparation and maintenance tools).
 */
export const footerVisual = {
  image: "/images/company/tube-cleaning-services.webp",
  width: 648,
  height: 550,
  alt: "Shingare technician cleaning the tube sheet of a heat exchanger with a tube-cleaning lance and hose",
  eyebrow: "Engineered for industry",
  description: "Precision tools for tube cleaning, pipe preparation and industrial maintenance.",
  position: { base: "50% 4%", md: "50% 3%" },
};
